// NOTE: P&L과 margin, balance는 모두 USDT, 2자리로 통일한다.
// 또한 WS margin의 currency는 항상 USDT다.
// https://prextech.slack.com/archives/G011DKZ8AHL/p1672123304330989
export const UsdCurrency = 'USD';
export const UsdPrecision = 2;

export const UsdtCurrency = 'USDT';
export const UsdtPrecision = 2;

export const PusdtCurrency = 'PUSDT';
export const PusdtDisplayName = 'Premium Earn'; // * 유저에게 절대 PUSDT로 보여지면 안됨.

export const Usd1Currency = 'USD1';
export const Usd1Precision = 2;

export const UsdeCurrency = 'USDE';
export const UsdePrecision = 2;

export const BitcoinCurrency = 'BTC';
export const EthereumCurrency = 'ETH';
export const NonUsdPrecision = 8;

export const BonusCurrency = 'AQXP';

export const UsdtCurrencyList = [PusdtCurrency, UsdtCurrency] as const;
// Trading bonus를 받으려면 USDT로 거래해야 하는 목록
export const TradingBonusUsdtCurrencies = [
  UsdtCurrency,
  PusdtCurrency,
  UsdeCurrency,
  BitcoinCurrency,
  EthereumCurrency,
] as const;
export const UsdCurrencyList = [PusdtCurrency, UsdtCurrency, Usd1Currency, UsdeCurrency] as const;
export const QuoteCurrencyListExceptUsdt = [Usd1Currency] as const;
export const QuoteCurrencyList = [UsdtCurrency, ...QuoteCurrencyListExceptUsdt] as const;
export const NonUsdCurrencyList = [BitcoinCurrency, EthereumCurrency] as const;

export const FundingRatePrecision = 4;
export const AssetPrecision = 8;

export const SparkPointPrecision = 2;

export const maxDecimalPrecision = 18;
export const FeePrecision = 8;

export const CurrencyPrecisionMapper: Record<(typeof QuoteCurrencyList)[number], number> = {
  [UsdtCurrency]: UsdtPrecision,
  [Usd1Currency]: Usd1Precision,
} as const;
